import React, { Component } from 'react'
import { connect } from 'react-redux'

import { actualizarDatosParaMuiTable } from '../actions/TablaDetallePorCondicionLinea5Actions'
import { TablaDetallePorCondicionLinea5View } from '../components/TablaDetallePorCondicionLinea5View'

class TablaDetallePorCondicionLinea5 extends Component {
  componentDidMount () {
    this.props.actualizarDatosParaMuiTable()
  }

  render () {
    return <TablaDetallePorCondicionLinea5View />
  }
}

const mapActionsToProps = {
  actualizarDatosParaMuiTable
}
const withRedux = connect(null, mapActionsToProps)

export default withRedux(TablaDetallePorCondicionLinea5)
